
<div class="main-container">
    <div class="close-btn-container" (click)="close()">
        <img src="../../assets/icons/close.svg" alt="Close Icon" class="close-icon">
    </div>
    <div class="disease-pin-close-container">
        <div class="header-container-new-disease-pin">
            <span><img src="../../assets/icons/disease_pin.png" alt="New Pin Icon" class="new-disease-pin-header-icon"> </span>
            <h1 mat-dialog-title  class="new-disease-pin-header">{{ 'NEW-PIN-TYPE-DIALOG.DISEASE-TITLE' | translate }}</h1>
        </div>
    </div>

    <div class="disease-pin-info-container">

        <div class="disease-pin-container">
            <div class="disease-pin-headers">
                <p class="disease-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.DATE-TIME' | translate }}:</p>
                <p class="disease-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.LATITUDE' | translate }}:</p>
                <p class="disease-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.LONGITUDE' | translate }}:</p>
                <p class="disease-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.FARM' | translate }}:</p>
                <p class="disease-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.FIELD' | translate }}:</p>
                <p class="disease-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.CREATED-BY' | translate }}:</p>
            </div>

        </div>

        <div class="disease-pin-container">
            <ng-container>
                <p class="disease-pin-info-text">{{pinObj.date ? dayjs(pinObj.date).format(dateStringFormatting) : placeholder}}</p>
                <p class="disease-pin-info-text">{{pinObj.lat}}</p>
                <p class="disease-pin-info-text">{{pinObj.lng}}</p>
                <p class="disease-pin-info-text">{{pinObj.farm}}</p>
                <p class="disease-pin-info-text">{{pinObj.field}}</p>
                <p class="disease-pin-info-text">{{pinObj.creatingUser}}</p>
            </ng-container>

        </div>
    </div>

    <form [formGroup]="updatePinForm">
        <mat-form-field class="disease-pin-input" appearance="outline">
            <mat-label>{{'NEW-SAVE-PIN-DIALOG.PIN-NAME' | translate }}</mat-label>
            <input matInput formControlName="pinDescription">
            <mat-error *ngIf="updatePinForm.get('pinDescription').invalid"  class="error-notice">
                Required* - Pin Name
            </mat-error>
        </mat-form-field>

    <div class="disease-pin-btn-container">
        <div class="disease-pin-delete-btn-container">
            <button class="delete-disease-pin-btn" mat-flat-button type="button" (click)="openDeletePinDialog()">
                <div class="disease-pin-btn-content">
                    <img src="../../assets/icons/delete.svg" alt="Delete Icon" class="new-disease-pin-btn-icon">
                    <span><p class="disease-pin-btn-text">{{ 'NEW-PIN-TYPE-DIALOG.DELETE-PIN' | translate }}</p></span>
                </div>
            </button>
        </div>

        <!-- <div class="disease-pin-open-disease-btn-container">
            <button class="open-disease-pin-btn" mat-flat-button type="button">
                <div class="disease-pin-btn-content">
                    <span><p class="disease-pin-btn-text">{{ 'NEW-PIN-TYPE-DIALOG.COVERT-PIN' | translate }}</p></span>
                </div>
            </button>
        </div> -->

        <div class="disease-pin-update-btn-container">
            <button class="update-disease-pin-btn" mat-flat-button type="button" (click)="updatePin()">
                <div class="disease-pin-btn-content">
                    <span><p class="disease-pin-btn-text">{{ 'NEW-PIN-TYPE-DIALOG.UPDATE-PIN' | translate }}</p></span>
                </div>
            </button>
        </div>

    </div>

</form>

</div>


